<template>
  <div class="common-back-button">
    <img src="/images/game/back.png" @click="onClick" />
  </div>
</template>

<script>
export default {
  name: "BackButton",
  methods: {
    onClick() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="scss" scoped>
.common-back-button {
  position: absolute;
  width: 80px;
  height: 40px;
  cursor: pointer;

  img {
    width: 100%;
  }

  img:hover {
    box-shadow: 0px 2px 27px 7px rgba(250, 100, 0, 0.43);
  }
}
</style>